import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react'

import { ONBOARDING_COMFORT_LEVEL_OPTIONS } from 'features/onboarding/constants'
import RadioGroup from 'components/ui/radio-group'
import Button from 'components/ui/button'
import Text from 'components/ui/text'
import { useOnboarding } from 'features/onboarding/hooks/use-onboarding'
import {
  ONBOARDING_STEPS,
  TRANSLATION_KEYS,
} from 'features/onboarding/config/steps'
import { translate } from 'utils/translation'

interface Step3Props {
  onNext: () => void
  onPrevious: () => void
}

export const Step3 = ({ onNext, onPrevious }: Step3Props) => {
  const onboardingState = useOnboarding()

  const handleComfortLevelChange = (value: string) => {
    if (value) {
      onboardingState.updateFormData({ step3: { comfortLevel: value } })
      onNext()
    }
  }

  return (
    <section className="tw-mx-auto tw-flex tw-min-h-[calc(100vh-200px)] tw-w-full tw-max-w-[640px] tw-flex-col">
      <div className="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-start tw-gap-8 tw-pt-8 tw-text-center">
        <Text
          as="h2"
          id="step-heading"
          className="tw-m-0 tw-text-2xl tw-font-bold md:tw-text-3xl"
          boldClassName="tw-text-orange-500"
        >
          {ONBOARDING_STEPS.step3.title}
        </Text>

        <RadioGroup
          name="comfort-level"
          options={ONBOARDING_COMFORT_LEVEL_OPTIONS}
          variant="card"
          className="tw-w-full tw-max-w-[320px]"
          onChange={handleComfortLevelChange}
        />

        <div className="tw-mt-auto tw-flex tw-justify-center tw-gap-3">
          <Button
            size="lg"
            variant="neutral-outlined"
            onClick={onPrevious}
            aria-label={translate(TRANSLATION_KEYS.backButton)}
          >
            <IconChevronLeft size={20} aria-hidden="true" />{' '}
            {translate(TRANSLATION_KEYS.backButton)}
          </Button>
          <Button
            size="lg"
            variant="neutral-outlined"
            onClick={onNext}
            aria-label={translate(TRANSLATION_KEYS.skipButton)}
          >
            {translate(TRANSLATION_KEYS.skipButton)}{' '}
            <IconChevronRight size={20} aria-hidden="true" />
          </Button>
        </div>
      </div>
    </section>
  )
}
